import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useHealthQuery } from '../../store/kopiliot-api/base-api'
import Spinner from '../spinner/Spinner'

const Footer = () => {
  const { data, isLoading, isFetching, error } = useHealthQuery()
  return (
    <footer className="footer">
      <Row className="justify-content-between text-center fs--1 mt-4 mb-3">
        <Col sm="auto">
          <p className="mb-0 text-600">
            KOPILIOT
            <span className="d-none d-sm-inline-block">| </span>
            <br className="d-sm-none" /> {new Date().getFullYear()} &copy;{' '}
            <a href="https://arkhale.com">Arkhale SAS</a>
          </p>
        </Col>
        <Col sm="auto">
          {isFetching || isLoading || !data ? (
            <Spinner />
          ) : (
            <p className="mb-0 text-600">v{data.version}</p>
          )}
        </Col>
      </Row>
    </footer>
  )
}

export default Footer
